/*
  Trial banner on every page. Merged FIRST into TRANSLATION_MAPS in ./index.js,
  so existing translations (Billing) still win. Keys are the English source.
*/

const ru = {
  "Trial until {date} ({days} days left). On that day your card will be charged {amount}.": "Пробный период до {date} (осталось дней: {days}). В этот день с карты спишется {amount}.",
  "Without payment, campaigns turn off and links stop opening.": "Без оплаты кампании выключатся, ссылки перестанут открываться.",
  "Billing": "Оплата",
};

const es = {
  "Trial until {date} ({days} days left). On that day your card will be charged {amount}.": "Prueba hasta el {date} (quedan {days} días). Ese día se cobrará {amount} a tu tarjeta.",
  "Without payment, campaigns turn off and links stop opening.": "Sin pago, las campañas se desactivan y los enlaces dejan de abrirse.",
  "Billing": "Facturación",
};

const pt = {
  "Trial until {date} ({days} days left). On that day your card will be charged {amount}.": "Teste até {date} (faltam {days} dias). Nesse dia, seu cartão será cobrado em {amount}.",
  "Without payment, campaigns turn off and links stop opening.": "Sem pagamento, as campanhas são desativadas e os links deixam de abrir.",
  "Billing": "Cobrança",
};

const de = {
  "Trial until {date} ({days} days left). On that day your card will be charged {amount}.": "Testphase bis {date} (noch {days} Tage). An diesem Tag wird deine Karte mit {amount} belastet.",
  "Without payment, campaigns turn off and links stop opening.": "Ohne Zahlung werden Kampagnen ausgeschaltet und Links öffnen sich nicht mehr.",
  "Billing": "Abrechnung",
};

const fr = {
  "Trial until {date} ({days} days left). On that day your card will be charged {amount}.": "Essai jusqu’au {date} ({days} jours restants). Ce jour-là, votre carte sera débitée de {amount}.",
  "Without payment, campaigns turn off and links stop opening.": "Sans paiement, les campagnes sont désactivées et les liens ne s’ouvrent plus.",
  "Billing": "Facturation",
};

const it = {
  "Trial until {date} ({days} days left). On that day your card will be charged {amount}.": "Prova fino al {date} (mancano {days} giorni). Quel giorno sulla tua carta verranno addebitati {amount}.",
  "Without payment, campaigns turn off and links stop opening.": "Senza pagamento le campagne vengono disattivate e i link smettono di aprirsi.",
  "Billing": "Fatturazione",
};

const pl = {
  "Trial until {date} ({days} days left). On that day your card will be charged {amount}.": "Okres próbny do {date} (zostało dni: {days}). Tego dnia z karty zostanie pobrane {amount}.",
  "Without payment, campaigns turn off and links stop opening.": "Bez płatności kampanie zostaną wyłączone, a linki przestaną się otwierać.",
  "Billing": "Rozliczenia",
};

const tr = {
  "Trial until {date} ({days} days left). On that day your card will be charged {amount}.": "{date} tarihine kadar deneme ({days} gün kaldı). O gün kartınızdan {amount} çekilecek.",
  "Without payment, campaigns turn off and links stop opening.": "Ödeme olmadan kampanyalar kapanır ve bağlantılar açılmaz.",
  "Billing": "Faturalandırma",
};

const uk = {
  "Trial until {date} ({days} days left). On that day your card will be charged {amount}.": "Пробний період до {date} (залишилось днів: {days}). Цього дня з картки буде списано {amount}.",
  "Without payment, campaigns turn off and links stop opening.": "Без оплати кампанії вимкнуться, посилання перестануть відкриватися.",
  "Billing": "Оплата",
};

const TRIAL_BANNER = { ru, es, pt, de, fr, it, pl, tr, uk };
export default TRIAL_BANNER;
